import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { RecommendationStatus } from "src/app/models/recommendation/recommendation-status";
import { RecommendationService } from "src/app/services/recommendation/recommendation.service";

@Injectable()
export class RecommendationStatusResolver implements Resolve<any> {
    
    constructor(private recommendationService: RecommendationService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Observable<RecommendationStatus[]>> {
        const response = this.recommendationService.getStatus().pipe(map(response => { 
            if (response.success) {
                return response.payload.statuses;
            }
            else {
                return [];
            }
        }));
        const responsePromise = new Promise<Observable<RecommendationStatus[]>>((resolve, reject) => { resolve( response )});
        return responsePromise;
    }

}